import { render, staticRenderFns } from "./dataStatByDay.vue?vue&type=template&id=88700a7c&scoped=true&"
import script from "./dataStatByDay.vue?vue&type=script&lang=js&"
export * from "./dataStatByDay.vue?vue&type=script&lang=js&"
import style0 from "./dataStatByDay.vue?vue&type=style&index=0&id=88700a7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88700a7c",
  null
  
)

export default component.exports